module.exports = __webpack_public_path__ + "static/img/c-bg2.6584d6d0.png";